import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Icon,
  IconButton,
  Spinner,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tooltip,
  Tr,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import download from 'downloadjs';
import React, { useEffect, useState } from 'react';
import {
  BsEnvelopeSlashFill,
  FaCloudUploadAlt,
  FaEdit,
  FaEye,
  FaFileDownload,
} from 'react-icons/all';
import { FaTrash } from 'react-icons/fa';
import { FiDownload, FiSearch } from 'react-icons/fi';
import { useHistory, useLocation } from 'react-router-dom';
import ReactDatePicker from 'react-datepicker';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import {
  Heading,
  Input,
  Pagination,
  Select,
  StatusBadge,
  Table,
} from '~/components';
import { ConfirmationDialog } from '~/components/ConfirmationDialog';
import { useQueryParams, useRoleCan } from '~/hooks';
import { useAnnouncements } from '~/hooks/useAnnouncements';
import {
  cancelAnnouncement,
  deleteAnnouncement,
  downloadFiles,
  getAnnouncementsById,
  getXlsComunicado,
  publishAnnouncement,
  setarStatusLidoAnnouncement,
} from '~/services/Announcements';
import {
  AnnouncementsFile,
  AnnouncementsStatus,
  AnnouncementsView,
} from '~/types/announcements';
import { AnnouncementDialog } from '~/components/AnnouncementDialog';
import { formatDate, parseDate } from '~/utils/formatDate';
import { PAGE_SIZE } from '~/constants';
import { updateUrlParams } from '~/utils/updateUrlParams';
import { queryClient } from '~/utils/react-query';

export const Announcements: React.VFC = () => {
  const queryParams = useQueryParams();
  const location = useLocation();
  const history = useHistory();

  const toast = useToast();
  const {
    isOpen: isOpenModalViewComunicado,
    onOpen: onOpenModalViewComunicado,
    onClose: onCloseModalViewComunicado,
  } = useDisclosure();
  const {
    isOpen: isOpenModal,
    onOpen: onOpenModal,
    onClose: onCloseModal,
  } = useDisclosure();
  const {
    isOpen: isOpenModalCancelar,
    onOpen: onOpenModalCancelar,
    onClose: onCloseModalCancelar,
  } = useDisclosure();
  const {
    isOpen: isOpenModalPublicar,
    onOpen: onOpenModalPublicar,
    onClose: onCloseModalPublicar,
  } = useDisclosure();
  const userIsAdmin = useRoleCan({ roles: ['administrador'] });

  const [idSelecionado, setIdSelecionado] = useState<number>();
  const [motivo, setMotivo] = useState<string>('');
  const [isFetching, setIsFetching] = useState(false);

  // Modal de visualização
  const [statusView, setStatusView] = useState(0);
  const [exigirCienciaView, setExigirCienciaView] = useState(false);
  const [tituloView, setTituloView] = useState('');
  const [mensagemView, setMensagemView] = useState('');
  const [arquivosView, setArquivosView] = useState<AnnouncementsFile[]>([]);
  const [dataPublicacaoView, setDataPublicacaoView] = useState('');
  const [motivoCancelamentoView, setMotivoCancelamentoView] = useState('');
  const [cienteClienteView, setCienteClienteView] = useState(false);
  const [isLoadingDownload, setIsLoadingDownload] = useState(false);
  // TODO: add order e order by
  const [parametros, setParametros] = useState(() => {
    const dataInicio = queryParams.get('dataInicial');
    const dataFim = queryParams.get('dataFinal');

    const parsedDataInicio = dataInicio
      ? parseDate(dataInicio, 'yyyy-MM-dd')
      : undefined;

    const parsedDataFim = dataFim
      ? parseDate(dataFim, 'yyyy-MM-dd')
      : undefined;

    return {
      busca: queryParams.get('busca') ?? '',
      situacao: queryParams.get('situacao') ?? '',
      dataInicial: parsedDataInicio ? parsedDataInicio.toISOString() : '',
      dataFinal: parsedDataFim ? parsedDataFim.toISOString() : '',
      pagina: queryParams.get('pagina') ?? '1',
      paginacao: queryParams.get('paginacao') ?? PAGE_SIZE.toString(),
      order: queryParams.get('order') ?? 'DESC',
      orderBy: queryParams.get('orderBy') ?? '',
    };
  });

  const situacao = [
    { value: '', label: 'Todos' },
    { value: '0', label: 'Rascunho' },
    { value: '1', label: 'Publicado' },
    { value: '2', label: 'Cancelado' },
  ];

  const situacaoCliente = [
    { value: '', label: 'Todos' },
    { value: '0', label: 'Não lido' },
    { value: '1', label: 'Lido' },
    { value: '2', label: 'Cancelado' },
  ];

  const { data, isLoading, refetch } = useAnnouncements(
    userIsAdmin,
    Number(parametros.pagina) ?? 1,
    parametros.busca,
    parametros.situacao,
    parametros.dataInicial,
    parametros.dataFinal,
    Number(parametros.paginacao),
    parametros.order,
  );

  window.addEventListener('comunicado-lido-notificacao', () => {
    refetch();
  });

  useEffect(() => {
    const pagina = queryParams.get('pagina');
    const dataInicial = queryParams.get('dataInicial');
    const dataFinal = queryParams.get('dataFinal');

    setParametros({
      ...parametros,
      pagina: pagina ?? '1',
    });
    updateUrlParams(
      {
        ...parametros,
        pagina: pagina ?? '1',
        dataInicial: dataInicial ?? '',
        dataFinal: dataFinal ?? '',
      },
      history,
    );
  }, [location.search]);

  const handleDataInicial = (e?: Date) => {
    const dataFinal = queryParams.get('dataFinal');

    const formatedDate = e ? e.toISOString().split('T')[0] : '';

    setParametros({
      ...parametros,
      pagina: '1',
      dataInicial: e ? e.toISOString() : '',
    });
    updateUrlParams(
      {
        ...parametros,
        pagina: '1',
        dataInicial: formatedDate,
        dataFinal: dataFinal ?? '',
      },
      history,
    );
  };

  const handleDataFinal = (e?: Date) => {
    const dataInicial = queryParams.get('dataInicial');

    const formatedDate = e ? e.toISOString().split('T')[0] : '';

    setParametros({
      ...parametros,
      pagina: '1',
      dataFinal: e ? e.toISOString() : '',
    });
    updateUrlParams(
      {
        ...parametros,
        pagina: '1',
        dataFinal: formatedDate,
        dataInicial: dataInicial ?? '',
      },
      history,
    );
  };

  const handlePageSizeChange = (e: any) => {
    const dataInicial = queryParams.get('dataInicial');
    const dataFinal = queryParams.get('dataFinal');
    setParametros({
      ...parametros,
      paginacao: e.target.value,
      pagina: '1',
    });
    updateUrlParams(
      {
        ...parametros,
        paginacao: e.target.value,
        pagina: '1',
        dataInicial: dataInicial ?? '',
        dataFinal: dataFinal ?? '',
      },
      history,
    );
  };

  const novoComunicado = () => {
    history.push('/portal/admin/announcements/new-announcements/');
  };

  const editarComunicado = (id: number) => {
    history.push(`/portal/admin/announcements/new-announcements/${id}/edit`);
  };

  const visualizarComunicado = (msg: AnnouncementsView) => {
    if (userIsAdmin) {
      history.push(`/portal/admin/announcements-datail/${msg.id}`);
    } else {
      // eslint-disable-next-line no-param-reassign
      msg.isLoading = true;
      setIsFetching(true);
      setIdSelecionado(msg.id);
      getAnnouncementsById(msg.id!.toString())
        .then(response => {
          handleDialogViewComunicado(response);
        })
        .finally(() => {
          // eslint-disable-next-line no-param-reassign
          msg.isLoading = false;
          setIsFetching(false);
        });
    }
  };

  const exportarComunicado = (id: number) => {
    setIsLoadingDownload(true);
    getXlsComunicado(id)
      .then(r => {
        if (r.data.size > 0) {
          download(
            new Blob([r.data], { type: r.data.type }),
            r.headers['content-disposition'].match(/filename="(.+)"/)[1],
          );
        } else {
          toast({
            title: r?.data?.error,
            description: 'Entre em contato para mais informações',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        }
        setIsLoadingDownload(false);
      })
      .catch(err => {
        toast({
          title: `Erro`,
          description: err.message,
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        setIsLoadingDownload(false);
      });
  };

  const excluirComunicado = () => {
    setIsFetching(true);
    deleteAnnouncement(idSelecionado!)
      .then(() => {
        refetch();
        toast({
          title: 'Comunicado excluído com sucesso',
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        onCloseModal();
      })
      .catch(() => {
        toast({
          title: 'Erro ao excluir comunicado',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      })
      .finally(() => setIsFetching(false));
  };

  const cancelarComunicado = () => {
    setIsFetching(true);
    cancelAnnouncement(idSelecionado!, motivo.trim())
      .then(() => {
        refetch();
        toast({
          title: 'Comunicado cancelado com sucesso',
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        handleCloseModalCancelar();
      })
      .catch(() => {
        toast({
          title: 'Erro ao cancelar comunicado',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      })
      .finally(() => setIsFetching(false));
  };

  const setCienciaCliente = () => {
    setIsFetching(true);
    setarStatusLidoAnnouncement(idSelecionado!)
      .then(() => {
        refetch();
        const event = new CustomEvent('comunicado-lido');
        window.dispatchEvent(event);
        onCloseModalViewComunicado();
      })
      .catch(() => null)
      .finally(() => setIsFetching(false));
  };

  const handleCloseModalCancelar = () => {
    setMotivo('');
    onCloseModalCancelar();
  };

  const downloadArquivo = (id: number, multiplosArquivos = false) => {
    setIsFetching(true);
    downloadFiles(id)
      .then(r => {
        if (r?.data?.size > 0) {
          const nomeArquivo = multiplosArquivos
            ? 'arquivos.zip'
            : r.headers['content-disposition'].match(/filename="(.+)"/)[1];
          download(new Blob([r.data], { type: r.data.type }), nomeArquivo);
        } else {
          toast({
            title: r?.data?.error,
            description: 'Entre em contato para mais informações',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        }
      })
      .catch(() => {
        toast({
          title: 'Documento não encontrado',
          description: 'Entre em contato para mais informações',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      })
      .finally(() => setIsFetching(false));
  };

  const publicarComunicado = (id: number) => {
    setIsFetching(true);
    publishAnnouncement(id)
      .then(() => {
        refetch();
        toast({
          title: 'Comunicado publicado com sucesso',
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        queryClient.invalidateQueries('announcements');
        onCloseModalPublicar();
      })
      .catch(() => {
        toast({
          title: 'Erro ao publicar comunicado',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      })
      .finally(() => setIsFetching(false));
  };

  function handleDialogViewComunicado(response: AnnouncementsView) {
    setCienteClienteView(false);
    setExigirCienciaView(response.exigir_ciencia);
    setStatusView(response.status_cliente || 0);
    setTituloView(response.titulo);
    setMensagemView(response.mensagem);
    setArquivosView(response.formattedFiles);
    setDataPublicacaoView(response.formattedDateTime);
    if (response.motivo_cancelamento) {
      setMotivoCancelamentoView(response.motivo_cancelamento);
    }
    onOpenModalViewComunicado();
  }

  return (
    <Box px="8" py="4">
      <HStack gridGap={3}>
        <Heading>Comunicados</Heading>
        {isLoading && <Spinner />}
      </HStack>
      <HStack py={8} justifyContent="space-between" alignItems="flex-end">
        <HStack alignItems="flex-end" gridGap={3} w="65%">
          <Input
            name="search"
            type="text"
            icon={FiSearch}
            value={parametros.busca}
            onChange={e => {
              const dataInicial = queryParams.get('dataInicial');
              const dataFinal = queryParams.get('dataFinal');
              setParametros({
                ...parametros,
                pagina: '1',
                busca: e.target.value,
              });
              updateUrlParams(
                {
                  ...parametros,
                  pagina: '1',
                  busca: e.target.value,
                  dataInicial: dataInicial ?? '',
                  dataFinal: dataFinal ?? '',
                },
                history,
              );
            }}
            placeholder="Procure pelo assunto"
            fontSize="15px"
            label=""
          />
          <Select
            name="situacao"
            fontSize="15px"
            value={parametros.situacao}
            label="Situação"
            isDisabled={isFetching}
            onChange={e => {
              const dataInicial = queryParams.get('dataInicial');
              const dataFinal = queryParams.get('dataFinal');
              setParametros({
                ...parametros,
                pagina: '1',
                situacao: e.target.value,
              });
              updateUrlParams(
                {
                  ...parametros,
                  pagina: '1',
                  situacao: e.target.value,
                  dataInicial: dataInicial ?? '',
                  dataFinal: dataFinal ?? '',
                },
                history,
              );
            }}
          >
            {userIsAdmin &&
              situacao?.map(s => (
                <option key={s.value} value={s.value}>
                  {s.label}
                </option>
              ))}
            {!userIsAdmin &&
              situacaoCliente?.map(s => (
                <option key={s.value} value={s.value}>
                  {s.label}
                </option>
              ))}
          </Select>
          <FormControl maxW="200px">
            <FormLabel style={{ fontSize: '14px' }}>
              Selecione o período
            </FormLabel>
            <ReactDatePicker
              dateFormat="dd/MM/yyyy"
              showTimeSelect={false}
              todayButton="Today"
              isClearable
              locale="ptBR"
              placeholderText="Data inicial"
              shouldCloseOnSelect
              onChange={input => {
                if (input === null) handleDataInicial(undefined);
              }}
              onChangeRaw={e => {
                const date = formatDate(e.target.value);
                if (date) {
                  handleDataInicial(parseDate(date, 'dd/MM/yyyy'));
                }
              }}
              onSelect={date => {
                handleDataInicial(date);
              }}
              selected={
                parametros.dataInicial.length > 0
                  ? new Date(parametros.dataInicial)
                  : undefined
              }
            />
          </FormControl>
          <Text>a</Text>
          <FormControl maxW="200px">
            <ReactDatePicker
              dateFormat="dd/MM/yyyy"
              showTimeSelect={false}
              todayButton="Today"
              isClearable
              locale="ptBR"
              placeholderText="Data final"
              shouldCloseOnSelect
              onChange={input => {
                if (input === null) handleDataFinal(undefined);
              }}
              onChangeRaw={e => {
                const date = formatDate(e.target.value);
                if (date) {
                  handleDataFinal(parseDate(date, 'dd/MM/yyyy'));
                }
              }}
              onSelect={date => {
                handleDataFinal(date);
              }}
              selected={
                parametros.dataFinal.length > 0
                  ? new Date(parametros.dataFinal)
                  : undefined
              }
            />
          </FormControl>
        </HStack>
        {userIsAdmin && (
          <Button
            type="button"
            color="white"
            background="gray.900"
            _hover={{
              bgColor: 'black',
            }}
            onClick={() => novoComunicado()}
          >
            Novo comunicado
          </Button>
        )}
      </HStack>
      <Table type="custom">
        <Thead>
          <Tr>
            <Th>TÍTULO</Th>
            <Th>MENSAGEM</Th>
            <Th>
              <Flex
                gap={2}
                cursor="pointer"
                onClick={() => {
                  const order = queryParams.get('order');
                  const dataInicial = queryParams.get('dataInicial');
                  const dataFinal = queryParams.get('dataFinal');
                  setParametros({
                    ...parametros,
                    order: order === 'ASC' ? 'DESC' : 'ASC',
                    pagina: queryParams.get('pagina') ?? '1',
                  });
                  updateUrlParams(
                    {
                      ...parametros,
                      order: order === 'ASC' ? 'DESC' : 'ASC',
                      pagina: queryParams.get('pagina') ?? '1',
                      dataInicial: dataInicial ?? '',
                      dataFinal: dataFinal ?? '',
                    },
                    history,
                  );
                }}
              >
                DATA PUBLICAÇÃO{' '}
                {parametros.order === 'ASC' ? (
                  <ChevronDownIcon fontSize={14} ml="2" />
                ) : (
                  <ChevronUpIcon fontSize={14} ml="2" />
                )}
              </Flex>
            </Th>
            {userIsAdmin && <Th>PUBLICADO POR</Th>}
            <Th textAlign="center">SITUAÇÃO</Th>
            <Th textAlign="center">DOCUMENTO</Th>
            <Th textAlign="center">AÇÕES</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data?.results.length ? (
            data?.results.map(msg => (
              <Tr key={msg.id}>
                <Td maxW="200px" verticalAlign="top">
                  <Text
                    overflowX="hidden"
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                    title={msg.titulo}
                  >
                    {msg.titulo}
                  </Text>
                </Td>
                <Td maxW="200px" verticalAlign="top">
                  {msg.formattedMensage?.length > 200 ? (
                    <Text
                      title={msg.formattedMessageTooltip}
                      dangerouslySetInnerHTML={{
                        __html: msg.formattedMensage.slice(0, 200),
                      }}
                    />
                  ) : (
                    <Text
                      title={msg.formattedMessageTooltip}
                      dangerouslySetInnerHTML={{
                        __html: msg.formattedMensage,
                      }}
                    />
                  )}
                </Td>
                <Td verticalAlign="top">{msg.formattedDate}</Td>
                {userIsAdmin && (
                  <Td verticalAlign="top">{msg?.usuario_publicacao || '-'}</Td>
                )}
                <Td textAlign="center" verticalAlign="top">
                  <StatusBadge variant={msg.statusColor}>
                    {msg.formattedStatus}
                  </StatusBadge>
                </Td>
                <Td textAlign="center" verticalAlign="top">
                  <Tooltip
                    hasArrow
                    label="Download"
                    bg="black"
                    shouldWrapChildren
                  >
                    <IconButton
                      isDisabled={msg.qtde_arquivos === 0 || isFetching}
                      aria-label="Download"
                      onClick={() =>
                        downloadArquivo(msg.id!, msg.qtde_arquivos! > 1)
                      }
                      icon={<Icon as={FiDownload} />}
                    />
                  </Tooltip>
                </Td>
                <Td verticalAlign="top">
                  <HStack gridGap={2} justifyContent="center">
                    {msg.status === AnnouncementsStatus.RASCUNHO &&
                    userIsAdmin ? (
                      <>
                        <Tooltip
                          hasArrow
                          label="Editar"
                          bg="black"
                          shouldWrapChildren
                        >
                          <IconButton
                            isDisabled={isFetching}
                            aria-label="Editar"
                            onClick={() => editarComunicado(msg.id!)}
                            icon={<Icon as={FaEdit} />}
                          />
                        </Tooltip>
                        <Tooltip
                          hasArrow
                          label="Excluir"
                          bg="black"
                          shouldWrapChildren
                        >
                          <IconButton
                            isDisabled={isFetching}
                            aria-label="Excluir"
                            onClick={() => {
                              setIdSelecionado(msg.id!);
                              onOpenModal();
                            }}
                            icon={<Icon as={FaTrash} />}
                          />
                        </Tooltip>
                        <Tooltip
                          hasArrow
                          label="Publicar"
                          bg="black"
                          shouldWrapChildren
                        >
                          <IconButton
                            isDisabled={isFetching}
                            onClick={() => {
                              setIdSelecionado(msg.id!);
                              onOpenModalPublicar();
                            }}
                            aria-label="Publicar"
                            icon={<Icon as={FaCloudUploadAlt} />}
                          />
                        </Tooltip>
                      </>
                    ) : (
                      <>
                        <Tooltip
                          hasArrow
                          label="Visualizar"
                          bg="black"
                          shouldWrapChildren
                        >
                          <IconButton
                            isDisabled={isFetching}
                            aria-label="Visualizar"
                            onClick={() => visualizarComunicado(msg!)}
                            icon={
                              msg.isLoading ? <Spinner /> : <Icon as={FaEye} />
                            }
                          />
                        </Tooltip>
                        {userIsAdmin && (
                          <Tooltip
                            hasArrow
                            label="Relatório"
                            bg="black"
                            shouldWrapChildren
                          >
                            <IconButton
                              aria-label="Relatório"
                              isDisabled={!msg.exigir_ciencia}
                              onClick={() => exportarComunicado(msg.id!)}
                              icon={<Icon as={FaFileDownload} />}
                            />
                          </Tooltip>
                        )}
                        {userIsAdmin && (
                          <Tooltip
                            hasArrow
                            label="Cancelar o comunicado"
                            bg="black"
                            shouldWrapChildren
                          >
                            <IconButton
                              isDisabled={
                                msg.status === AnnouncementsStatus.CANCELADO ||
                                isFetching
                              }
                              aria-label="Cancelar o comunicado"
                              onClick={() => {
                                setIdSelecionado(msg.id!);
                                onOpenModalCancelar();
                              }}
                              icon={<Icon as={BsEnvelopeSlashFill} />}
                            />
                          </Tooltip>
                        )}
                      </>
                    )}
                  </HStack>
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td textAlign="center" colSpan={6}>
                {isLoading ? <Spinner /> : 'Não há dados a serem apresentados'}
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>
      <Flex justify="flex-end">
        {data && (
          <Pagination
            totalCountOfRegisters={data.count}
            currentPage={Number(parametros.pagina) ?? 1}
            onPageChange={_page => {
              const dataInicial = queryParams.get('dataInicial');
              const dataFinal = queryParams.get('dataFinal');
              setParametros({ ...parametros, pagina: _page.toString() });
              updateUrlParams(
                {
                  ...parametros,
                  pagina: _page.toString(),
                  dataInicial: dataInicial ?? '',
                  dataFinal: dataFinal ?? '',
                },
                history,
              );
            }}
            onPageSizeChange={handlePageSizeChange}
            registersPerPage={Number(parametros.paginacao) ?? PAGE_SIZE}
          />
        )}
      </Flex>
      <ConfirmationDialog
        confirmar={excluirComunicado}
        onClose={onCloseModal}
        isOpen={isOpenModal}
        titulo="Deletar rascunho"
        isDisabled={isFetching}
      >
        <span>Tem certeza que deseja realizar esta ação?</span>
      </ConfirmationDialog>
      <ConfirmationDialog
        confirmar={cancelarComunicado}
        onClose={handleCloseModalCancelar}
        isOpen={isOpenModalCancelar}
        titulo="Cancelar comunicado"
        btnConfirmText="Sim, cancelar"
        btnCancelText="Fechar"
        isDisabled={!motivo.trim() || isFetching}
      >
        <span>
          Tem certeza que deseja cancelar o comunicado enviado? Alguns cliente
          já podem ter visualizado.
        </span>
        <FormControl>
          <FormLabel margin={0} fontSize="14px">
            <span style={{ color: 'red' }}>*</span> Informe o motivo do
            cancelamento:
          </FormLabel>
          <Textarea
            name="search"
            type="text"
            value={motivo}
            onChange={e => {
              if (e.target.value.length > 255) return;
              setMotivo(e.target.value);
            }}
            fontSize="15px"
          />
          <Text textAlign="end" color="blackAlpha.600" fontSize="14px">
            {motivo.length}/255
          </Text>
        </FormControl>
        <Text margin="0px">
          Ao confirmar esta ação não poderá ser desfeita.
        </Text>
      </ConfirmationDialog>
      <ConfirmationDialog
        confirmar={() => publicarComunicado(idSelecionado!)}
        onClose={onCloseModalPublicar}
        isOpen={isOpenModalPublicar}
        titulo="Publicar comunicado"
        btnConfirmText="Publicar"
        isDisabled={isFetching}
      >
        <span>
          Tem certeza que deseja publicar esse comunicado? Ao confirmar, esta
          ação não poderá ser desfeita.
        </span>
      </ConfirmationDialog>
      <AnnouncementDialog
        status={statusView}
        exigirCiencia={exigirCienciaView}
        setarStatusLido={setCienciaCliente}
        onCloseModal={onCloseModalViewComunicado}
        isOpenModal={isOpenModalViewComunicado}
        motivoCancelamento={motivoCancelamentoView}
        dataPublicacao={dataPublicacaoView}
        titulo={tituloView}
        mensagem={mensagemView}
        arquivos={arquivosView}
      />
    </Box>
  );
};
